import { render, staticRenderFns } from "./WorkPlace.vue?vue&type=template&id=7b917ab7&scoped=true"
import script from "./WorkPlace.vue?vue&type=script&lang=js"
export * from "./WorkPlace.vue?vue&type=script&lang=js"
import style0 from "./WorkPlace.vue?vue&type=style&index=0&id=7b917ab7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b917ab7",
  null
  
)

export default component.exports